var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6393D;}\n\t.st1{fill:#6BBE9E;}\n\t.st2{fill:#A9D8D5;stroke:#A9D8D5;stroke-width:2.25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#1C8079;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.49,101.97c-0.96-2.15-1.94-4.56-1.17-6.78c0.33-0.95,0.95-1.78,1.18-2.76c0.48-2.04-0.87-4.17-0.43-6.22 c0.37-1.69,1.86-2.88,2.77-4.36c1.48-2.4,0.83-6.25-1.86-7.08c-0.62-0.19-1.29-0.21-1.88-0.47c-2.76-1.25-1.67-6.56-4.59-7.4 c-0.54-0.15-1.11-0.1-1.66-0.04c-2.43,0.28-5.08,0.86-6.58,2.79c0.89-1.74-0.29-3.97-2.01-4.9c-1.72-0.93-3.78-0.92-5.73-0.88 c-1.23,0.02-2.49,0.05-3.62,0.52c-1.13,0.47-2.13,1.48-2.21,2.71c-0.27-2.04-2.55-3.42-4.6-3.13c-2.04,0.29-3.71,1.89-4.61,3.75 c-0.3,0.63-0.59,1.36-1.24,1.62c-0.4,0.16-0.84,0.11-1.27,0.14c-1.59,0.11-2.86,1.3-3.99,2.42c-0.67,0.67-1.37,1.37-1.72,2.25 c-0.35,0.88-0.27,2.01,0.44,2.64c-1.47-2.8-5.88-2.85-8.16-0.65s-2.72,5.73-2.23,8.85c1.1-1.03-0.04-3.13-1.55-3.23 c-1.51-0.1-2.81,1.14-3.46,2.5c-0.78,1.63-0.78,3.87,0.67,4.94c-0.48-1.47-2.75-1.53-3.85-0.44c-1.09,1.09-1.32,2.76-1.48,4.3 c-0.21,1.95-0.41,3.9-0.62,5.84c-0.07,0.64-0.14,1.3-0.39,1.9c-0.29,0.69-0.8,1.26-1.18,1.91c-1.16,1.94-1.04,4.55,0.28,6.38 c0.35,0.49,0.79,0.93,0.98,1.5c0.38,1.1-0.26,2.28-0.93,3.22c-0.67,0.95-1.45,1.96-1.41,3.12s1.53,2.22,2.39,1.44 c-0.52,0.24-0.98,0.61-1.35,1.05c-1.37,1.65-1.25,4.34,0.26,5.86c0.26,0.26,0.57,0.52,0.63,0.88c0.09,0.58-0.5,1.02-0.9,1.45 c-1.45,1.58-0.11,4.65,2.03,4.67l4.86,2.31c0.83,2.46,3.86,3.56,6.43,3.16c2.56-0.4,4.8-1.9,7.04-3.21 c1.09-0.63,2.37-1.25,3.55-0.83c1.72,0.6,2.19,2.99,3.83,3.78c1.32,0.64,2.94,0,4.01-1.01c1.07-1.01,1.77-2.33,2.72-3.45 c0.95-1.11,2.32-2.06,3.78-1.88c1.25,0.16,2.44,1.14,3.64,0.76c0.41-0.13,0.76-0.41,1.09-0.68c1.69-1.38,3.58-3.4,2.78-5.43 c0.32,0.75,0.65,1.51,0.97,2.26c2.26,0,4.52-0.4,6.64-1.19c1.75-0.65,3.62-1.87,3.73-3.73c0.06-0.99-0.4-1.92-0.64-2.88 s-0.15-2.16,0.69-2.69l2.86,0.9c-0.17,0.08,0.14,0.26,0.31,0.18c1.78-0.82,3.06-2.64,3.24-4.59c0.09-1-0.09-2-0.03-3.01 c0.06-1,0.44-2.07,1.31-2.57l1.62-2.13c0.4-0.67,0.56-1.48,0.46-2.25L143.49,101.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.58,84.42c-5.2,3.53-15.57,15.14-19.88,19.72c-1.79,1.9-3.5,3.88-5.2,5.86c-2.34,2.72-4.68,5.44-7.02,8.15 c-5.69,6.61-11.39,13.23-16.24,20.47c-1.34,2.01-2.62,4.06-3.99,6.05c0.95,0.85,2.83,1.76,3.64,2.74c1.34-3.13,2.41-6.57,4.49-9.27 c7.52-9.78,14.46-18.91,22.56-28.21L123.58,84.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.13,108.95c1.03-0.79,2.17-1.42,3.39-1.86c0.53-0.19,1.08-0.35,1.64-0.41c1.47-0.14,2.91,0.45,4.3,0.95 c1.67,0.6,3.38,1.09,5.11,1.46c1.38,0.29,2.46-1.19,3.66-1.92c-0.13-0.65,0.06-1.35,0.48-1.86c-0.37,0.66-0.75,1.34-0.91,2.08 c-0.16,0.74-0.08,1.58,0.39,2.17c0.67,0.83,1.87,0.96,2.93,0.99c1.3,0.04,2.63,0.02,3.83-0.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M126.25,116.14c-1.44-0.02-2.71,0.88-4.05,1.42c-2.39,0.98-5.21,0.85-7.49-0.36c-0.95-0.5-1.8-1.18-2.72-1.74 c-3.65-2.24-8.39-2.6-12.33-0.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.76,119.1c-0.17,0.05-0.09-0.27,0.07-0.35c2.11-1.07,4.7-0.95,6.88-0.04s4.01,2.53,5.53,4.35 c0.55,0.65,1.07,1.34,1.76,1.84s1.59,0.79,2.4,0.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.72,78.33c-1.35,4.33-1.23,9.1,0.34,13.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.54,76.91c-0.56,0.66-0.9,1.51-0.95,2.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.21,77.8c-0.73,1.95-0.8,4.13-0.2,6.12c0.03,0.1,0.08,0.22,0.17,0.26c0.1,0.04,0.24-0.08,0.17-0.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.87,72.93c-0.9,0.53-1.54,1.48-1.7,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.08,82.17c-1.19,5.07-0.25,10.61,2.55,15c0.15,0.23,0.38,0.49,0.64,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M121.81,118.13c-0.09,0.27-0.11,0.56-0.04,0.84c0.08,0.33,0.26,0.62,0.46,0.89c0.81,1.07,2.02,1.84,3.33,2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.34,119.26c1.42-0.45,3.01-0.32,4.33,0.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.22,124.08c2.38-1.37,5.49-1.77,7.82-0.32c1.32,0.82,2.39,2.21,3.93,2.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.88,127.39c-0.19,0.07-0.34-0.21-0.25-0.39c0.09-0.17,0.31-0.24,0.5-0.27c1.35-0.24,2.75,0.29,3.84,1.12 c1.09,0.83,1.94,1.93,2.77,3.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.78,120.63c-0.05-1.81-0.78-3.6-2.01-4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.69,114.54c-0.66-2.09-1.93-3.93-3.18-5.73c-1.05-1.5-2.27-3.13-4.06-3.49c-1.05-0.21-2.14,0.06-3.19-0.09 c-1.06-0.15-2.18-1.01-1.98-2.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.15,92.32c-0.89,1.3-0.8,3.08-0.2,4.54s1.62,2.7,2.56,3.96c1.68,2.26,3.13,4.69,4.31,7.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.54,97.86c0.85,0.8,1.6,1.7,2.23,2.69c0.33,0.53,0.64,1.11,0.66,1.73c0.03,1.13-0.9,2.14-0.81,3.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.72,87.41c-0.14,0.27-0.05,0.61,0.06,0.9c1.14,2.99,3.94,5,5.6,7.73c1.4,2.29,1.95,5.08,1.53,7.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.85,91.66c3.19-0.31,6.84,0.17,9.81-1.15c3.35-1.48,6.86-2.27,9.74,0.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.12,90.84c0.36,2.22,2.35,4.06,4.59,4.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollard);
export default __webpack_public_path__ + "static/media/Collard.84a4c7f13875d12a96730f60681f2f83.svg";
export { ForwardRef as ReactComponent };